<template src="./auditlog.html"></template>
<script>
  import VueGallery from "vue-gallery";
  import Multiselect from "vue-multiselect";
  import Axios from "axios";
  import $ from "jquery";
  import TaskAction from "@/config/TaskAction.js";
  var moment = require("moment");

  export default {
    components: {
      VueGallery,
      Multiselect,
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
      showstring: function (data) {
        if (data == "" || data == null) {
          return "";
        } else {
          return data.replaceAll("_", " ");
        }
      },
    },
    data() {
      return {
        basic: {
          currentPage: 1,
          totalPages: 0,
        },

        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        ShowLoader: false,
        trailersModule: false,
        SearchKey: "",
        fromDate: "",
        toDate: "",
        vrm: "",
        entity_type: "",
        user: "",
        task: "",
        AllUserList: [],
        AuditLogList: [],
        EntityTypes: [],
        TaskAction: TaskAction,
        ShowAuditInfoModel: "",
        AuditInfoDetails: [],
      };
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions["Audit Logs"] ||
          !AccountPermissions["Audit Logs"]["enable"]) &&
        (!AccountPermissions["Audit Log"] ||
          !AccountPermissions["Audit Log"]["enable"])
      ) {
        this.$router.push("/");
      }
      document.title = pbx_SiteTitle + " - Audit Log";
      this.GetCompanySubscription();
      this.GetAuditLogList();
      this.GetAllFleetUserList();
    },

    methods: {
      SearchVehicle() {
        this.GetVehicleChecksList("search");
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isTrailer = FleetSubscriptionModules.Trailers;
        if (isTrailer) {
          this.trailersModule = true;
        }
      },
      GetAllFleetUserList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.User.AllUser, obj).then((Response) => {
          if (Response.data.success) {
            this.AllUserList = Response.data.users;
          }
        });
      },
      GetAuditLogList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.vrm = this.vrm;
          obj.entity_type = this.entity_type;
          obj.user = this.user;
          obj.task = this.task;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.AuditLog.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            this.AuditLogList = Response.data.AuditLogList;
            this.EntityTypes = Response.data.EntityTypes;
          }
        });
      },
      ShowAuditInfoPopup(event) {
        this.ShowAuditInfoModel = true;
        this.AuditInfoDetails = event;
      },
    },
  };
</script>

<style type="text/css">
  .auditloglist .table th,
  .table td {
    padding: 0.5rem !important;
  }
  .auditloglist td.w100 {
    width: 100px !important;
    min-width: 100px !important;
  }
  .auditloglist td.w120 {
    width: 120px !important;
    min-width: 120px !important;
  }
  .auditloglist td.w150 {
    width: 150px !important;
    min-width: 150px !important;
  }
</style>
